import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SocialFacebookMessengerIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialFacebookMessenger",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M16 2.01c-7.89 0-14 5.78-14 13.57 0 4.08 1.67 7.6 4.4 10.04.23.2.37.49.38.8l.08 2.49a1.118 1.118 0 0 0 1.57.99l2.78-1.22c.24-.1.5-.12.75-.06 1.32.36 2.68.54 4.05.54 7.89 0 14-5.77 14-13.57S23.89 2.01 16 2.01m8.41 10.44-4.11 6.51c-.31.5-.82.84-1.4.94-.58.11-1.17-.03-1.64-.38l-3.27-2.45a.855.855 0 0 0-1.01 0l-4.42 3.35c-.59.45-1.36-.26-.96-.88l4.11-6.52c.31-.5.82-.84 1.4-.94.58-.11 1.17.03 1.64.38l3.27 2.45c.3.22.71.22 1.01 0l4.42-3.35c.59-.45 1.36.26.96.88Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M16 0C6.99 0 0 6.6 0 15.52 0 20.18 1.91 24.21 5.03 27c.26.23.42.56.43.91l.09 2.85c.03.91.97 1.5 1.8 1.13l3.18-1.4c.27-.12.57-.14.85-.06 1.46.4 3.01.61 4.63.61 9.01 0 16-6.6 16-15.52S25.01 0 16 0m9.92 11.38-5.57 8.61a.94.94 0 0 1-1.3.28l-5.16-3.34a.57.57 0 0 0-.65.01l-5.82 4.01c-.85.58-1.89-.42-1.33-1.29l5.57-8.61a.94.94 0 0 1 1.3-.28l5.16 3.34c.2.13.46.13.65-.01l5.82-4.01c.85-.59 1.89.42 1.33 1.29"
      })
    })
  }));
};
SocialFacebookMessengerIcon.displayName = 'SocialFacebookMessengerIcon';